import { render } from "./LiveQueueCard.vue?vue&type=template&id=b46b335e&scoped=true&ts=true"
import script from "./LiveQueueCard.vue?vue&type=script&lang=ts"
export * from "./LiveQueueCard.vue?vue&type=script&lang=ts"

import "./LiveQueueCard.vue?vue&type=style&index=0&id=b46b335e&scoped=true&lang=css"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46b335e"]])

export default __exports__